import * as React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import { BillType } from "../../../../interfaces/BillInterfaces";

const BillDetails = ({ row }: { row: BillType }): React.JSX.Element => {
  const { document } = row;
  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableCell>S.NO</TableCell>
          <TableCell>Description</TableCell>
          <TableCell>Total</TableCell>
          <TableCell>Quantity</TableCell>
        </TableHead>
        <TableBody>
          {document.billItems.map((item) => {
            const { description, sNo, grossTotal, quantity } = item;
            return (
              <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }} key={sNo}>
                <TableCell>{sNo}</TableCell>
                <TableCell>{description}</TableCell>
                <TableCell>{grossTotal}</TableCell>
                <TableCell>{quantity}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default BillDetails;
